import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../config.service';

@Injectable({
  providedIn: 'root',
})
export class HubApiService {
  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService
  ) {}

  getVariableFields<T>(
    clientCode: string,
    objects: string = 'Contact'
  ): Observable<T> {
    const query = new URLSearchParams({ objects });
    const url = `${this.configService.getBffUrl(
      'hub',
      `v1/${encodeURIComponent(clientCode)}/variablefields`
    )}?${query.toString()}`;
    return this.http.get<T>(url);
  }

  getUserInfo<T>(token: string, clientCode: string): Observable<T> {
    return this.http.get<T>(this.configService.getBffAuthUrl(), {
      headers: {
        token,
        companycode: clientCode,
      },
    });
  }

  leadInsert<T>(payload: {
    clientCode: string;
    [key: string]: unknown;
  }): Observable<T> {
    const query = new URLSearchParams({ clientCode: payload.clientCode });
    const url = `${this.configService.getBffUrl(
      'hub',
      'Integration/v2/LeadInsert',
      { public: true }
    )}?${query.toString()}`;
    return this.http.post<T>(url, payload);
  }

  contactInsert<T>(
    payload: Record<string, unknown>,
    endpointUrl?: string
  ): Observable<T> {
    const url =
      endpointUrl ||
      this.configService.getBffUrl('hub', 'v1/leads/ContactInsert', {
        public: true,
      });
    const body =
      'data.json' in payload
        ? payload
        : { 'data.json': JSON.stringify(payload) };
    return this.http.post<T>(url, body);
  }
}
